import { Component, HostBinding, Input, OnInit } from '@angular/core';

@Component({
  selector: 'cc-top-bar-item',
  templateUrl: './top-bar-item.component.html',
  styleUrls: ['./top-bar-item.component.scss']
})
export class TopBarItemComponent implements OnInit {
  @HostBinding('class.show-always') classShowAlways;
  @HostBinding('class.show-in-mobile') classShowInMobile;
  @Input() showAlways: boolean;
  @Input() showInMobile: boolean;

  constructor() {}

  ngOnInit() {
    this.classShowAlways = this.showAlways;
    this.classShowInMobile = this.showInMobile;
  }
}
